import { useNavigate } from "react-router-dom";
import Topo from "../Topo/topo";
import { usuariosAPI } from "../../servicos/usuarios";
import { FormField } from "../ui/form-field";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { useForm } from "react-hook-form";
import { toast } from "sonner";


function Incluir() {

    const breadcrumbs = ['Admin', 'Usuario', 'Novo'];

    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            us100_dsc_usuario: '',
            us100_dsc_email: '',
            us100_dsc_senha: '',
            senhaConfirm: '',
        },
        mode: 'onBlur',
    });

    const senhaAtual = watch('us100_dsc_senha');

    let navigate = useNavigate();
    const Voltar = () => {
        let path = '/admin/usuario';
        navigate(path);
    }

    const onSubmit = async (values) => {
        try {
            await usuariosAPI.post('/', {
                us100_dsc_usuario: values.us100_dsc_usuario,
                us100_dsc_email: values.us100_dsc_email,
                us100_dsc_senha: values.us100_dsc_senha,
            });
            toast.success('Usuário cadastrado com sucesso.');
            reset();
        } catch (erro) {
            let mensagem = 'Ops! Ocorreu um erro inesperado.';
            if (erro?.response?.data?.message) {
                if (erro.response?.status === 401) {
                    mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
                } else {
                    mensagem = erro.response.data.message;
                }
            } else if (erro.response?.status === 401) {
                mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
            }
            toast.error(mensagem);
        }
    };

    const onInvalidSubmit = () => {
        toast.error('Por favor, corrija os campos destacados.');
    };

    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Novo Usuário' breadcrumbs={breadcrumbs} btnincluir={false} admin={true}/>
                <div class="row row-padding-conteudo">
                    <div class="col-12">
                        <form class="row gy-4 gx-4" onSubmit={handleSubmit(onSubmit, onInvalidSubmit)}>
                            <div class="col-md-6">
                                <FormField
                                    id="us100_dsc_usuario"
                                    label="Nome do Usuário"
                                    error={errors.us100_dsc_usuario?.message}
                                >
                                    <Input
                                        id="us100_dsc_usuario"
                                        {...register('us100_dsc_usuario', {
                                            required: 'Informe o nome.',
                                            minLength: {
                                                value: 3,
                                                message: 'O nome deve possuir ao menos 3 caracteres.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="us100_dsc_email"
                                    label="E-mail"
                                    error={errors.us100_dsc_email?.message}
                                >
                                    <Input
                                        id="us100_dsc_email"
                                        type="email"
                                        {...register('us100_dsc_email', {
                                            required: 'Informe o e-mail.',
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: 'Informe um e-mail válido.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="us100_dsc_senha"
                                    label="Senha"
                                    error={errors.us100_dsc_senha?.message}
                                >
                                    <Input
                                        id="us100_dsc_senha"
                                        type="password"
                                        {...register('us100_dsc_senha', {
                                            required: 'Informe a senha.',
                                            minLength: {
                                                value: 6,
                                                message: 'A senha deve possuir ao menos 6 caracteres.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="us100_dsc_senha_2"
                                    label="Confirmação da Senha"
                                    error={errors.senhaConfirm?.message}
                                >
                                    <Input
                                        id="us100_dsc_senha_2"
                                        type="password"
                                        {...register('senhaConfirm', {
                                            required: 'Confirme a senha.',
                                            validate: (valor) =>
                                                valor === senhaAtual || 'As senhas devem estar iguais.',
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-12 tw-flex tw-justify-end tw-gap-3 tw-pt-2">
                                <Button type="button" variant="outline" onClick={Voltar} className="tw-min-w-[120px] tw-text-slate-700 dark:tw-text-white">
                                    Voltar
                                </Button>
                                <Button type="submit" className="tw-min-w-[140px]" disabled={isSubmitting}>
                                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Incluir;

